/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type DeleteTemplateMenuItem_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasAnyPublishedVersion: boolean, usedInOtherTemplates: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number } | null };

export const DeleteTemplateMenuItem_QuoteTemplateFragmentDoc = gql`
    fragment DeleteTemplateMenuItem_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  hasAnyPublishedVersion
  templateSharing {
    id
    latestSharedVersionNumber
  }
  usedInOtherTemplates
}
    `;